<template>
  <page-wrapper :title="'นัดหมายทั้งหมด'" :no-pad-btm="true">
    <!-- Appointment dialog -->
    <div v-if="isShowAppointmentMenu" class="dialog-bg">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "นัดวันให้บริการ" }}</p>
          <div class="close-btn" @click="hideAppointmentMenu">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <p>{{ "วันที่" }}</p>
          <el-date-picker
            id="appointment_date"
            v-model="form.dateTime"
            :placeholder="'ระบุวันที่'"
            class="item"
            name="appointment_date"
            type="date"
            format="dd MMMM yyyy"
          />
          <p class="mt-2">{{ "เวลานัด" }}</p>
          <el-time-picker
            id="appointment_start_time"
            v-model="form.startTime"
            :placeholder="'00:00'"
            class="item"
            name="appointment_start_time"
            format="HH:mm"
            type="time"
          ></el-time-picker>
          <p class="mt-2">{{ "ถึง" }}</p>
          <el-time-picker
            id="appointment_end_time"
            v-model="form.endTime"
            :placeholder="'00:00'"
            class="item"
            name="appointment_end_time"
            format="HH:mm"
            type="time"
          ></el-time-picker>
          <!-- Open when the api is done. -->
          <!-- <p class="mt-2">
            {{ "บันทึกการนัดบริการ" }}
          </p>
          <el-input
            type="textarea"
            rows="3"
            placeholder="ระบุข้อความ"
            v-model="form.note"
          ></el-input> -->
          <div class="button-wrapper">
            <button class="me-1 button cancel" @click="hideAppointmentMenu">
              {{ "ยกเลิก" }}
            </button>
            <button class="ms-1 button submit" @click="handleConfirmAppoint">
              {{ "บันทึก" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div v-if="isDesktop" class="content-wrapper">
      <div class="left">
        <user-info v-if="appointment" :appointment="appointment" />
        <registration-form
          v-if="registrationForm"
          :registration-form="registrationForm"
        />
      </div>
      <div class="right">
        <appointment-history
          v-if="isShowAppointmentHistory"
          :subscriber="subscriber"
          :services="services"
          @expandBillingCycle="handleExpandBillingCycle"
          @appoint="handleAppoint"
        />
      </div>
    </div>
    <div v-else class="content-wrapper">
      <appointment-history
        v-if="isShowAppointmentHistory"
        :subscriber="subscriber"
        :services="services"
        @expandBillingCycle="handleExpandBillingCycle"
        @appoint="handleAppoint"
      />
      <user-info v-if="appointment" :appointment="appointment" />
      <registration-form
        v-if="registrationForm"
        :registration-form="registrationForm"
      />
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import { toLocaleTH, getDurationAppointmentTimeText } from "@/lib/dateTime"
import { DatePicker, TimePicker } from "element-ui"
import { existValueAndEmptyString } from "@/lib/util"
import { DateTime } from "luxon"
import JobDetailRegistrationForm from "../components/JobDetailRegistrationForm"
import JobDetailUserInfo from "../components/JobDetailUserInfo"
import AppointmentHistory from "../components/AppointmentHistory"
import PageWrapper from "../components/SupplierPageWrapper"
import { mSize } from "../StaticVariable"

export default {
  components: {
    PageWrapper,
    "user-info": JobDetailUserInfo,
    "registration-form": JobDetailRegistrationForm,
    AppointmentHistory,
    "el-date-picker": DatePicker,
    "el-time-picker": TimePicker,
  },
  data() {
    const providerId = localStorage.getItem("supplierProviderId")

    return {
      windowWidth: window.innerWidth,
      providerId,
      appointmentById: {},
      appointment: null,
      registrationForm: null,
      subscriber: null,
      services: [],
      showAppointment: false,
      form: {
        appointment: null,
        dateTime: null,
        startTime: null,
        endTime: null,
        note: null,
      },
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize
    },
    appointmentId() {
      return this.$route.params.appointmentId
    },
    isShowAppointmentHistory() {
      return this.subscriber && this.services
    },
    isShowAppointmentMenu() {
      return this.showAppointment
    },
  },
  watch: {
    "form.dateTime": function formDateTimeWatcher(value) {
      if (!value) {
        this.form.dateTime = null
        this.form.startTime = null
        this.form.endTime = null
      }
    },
  },
  created() {
    this.setup()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    setup() {
      this.setupData()
    },
    async setupData() {
      await this.setupAppointments()
    },
    async setupAppointments() {
      try {
        const { appointment } = await this.fetchAppointmentDetail(
          this.appointmentId,
        )
        this.appointment = appointment

        const { registrationForm, subscriber } =
          await this.fetchSubscriberDetail(
            this.appointment.subscriptionMemberId,
          )
        this.registrationForm = registrationForm
        this.subscriber = subscriber

        const fetchAppointmentsParams = { provider_id: this.providerId }
        const appointments = await this.fetchAppointments(
          this.appointment.subscriptionMemberId,
          fetchAppointmentsParams,
        )
        this.appointmentById = this.groupBy(appointments, "service_id")

        this.updateServices()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    updateServices() {
      this.services = this.subscriber.services
        .filter((service) => service.providerId.toString() === this.providerId)
        .map((service) => {
          const {
            id,
            name,
            description,
            shortDescription,
            iconUrl,
            type,
            quota,
            mainOption,
            extraOption,
          } = service

          const appointments = this.appointmentById[id].map((appointment) => {
            const ISOdateTime = DateTime.fromISO(appointment.date_time)
            const time = getDurationAppointmentTimeText(
              appointment.date_time,
              appointment.date_time_end,
            )

            const { lastBillingCycle } = this.subscriber
            let isDisableAppointment =
              appointment.is_disable_appointment_by_note_invoice

            if (quota === 0) {
              isDisableAppointment = true
            } else if (
              lastBillingCycle &&
              !lastBillingCycle.canMakeAppointment
            ) {
              isDisableAppointment = true
            } else if (
              lastBillingCycle &&
              existValueAndEmptyString(
                lastBillingCycle.isDisableAppointmentByNoteInvoice,
              )
            ) {
              isDisableAppointment =
                lastBillingCycle.isDisableAppointmentByNoteInvoice
            }

            // disable ปุ่ม นัดหมาย ถ้าไม่ใช่การนัดครั้งแรกสุดที่ยังไม่ได้นัด
            const isDisableButton = false

            // ซ่อนรอบบิลที่ไม่ใช่รอบบิลล่าสุด
            const isExpandBillingCycle = true

            return {
              id: appointment.id,
              status: appointment.appointment_status,
              invoiceId:
                appointment.invoice_id !== undefined
                  ? appointment.invoice_id
                  : null,
              appointmentNo:
                appointment.appointment_no !== undefined
                  ? appointment.appointment_no
                  : null,
              date: toLocaleTH(ISOdateTime).toFormat("dd MMM yyyy"),
              time,
              route: !appointment.constraint.can_make_appointment
                ? {
                    name: "SupplierJobDetail",
                    params: { appointmentId: appointment.id },
                  }
                : null,
              constraint: {
                canMakeAppointment: appointment.constraint.can_make_appointment,
              },
              note: appointment.appointment_note || "-",
              quota,
              lastBillingCycle,
              isDisableAppointment,
              isDisableButton,
              isExpandBillingCycle,
            }
          })

          const histories = this.groupBy(appointments, "invoiceId")

          const disableButtonById = {}

          Object.values(histories).forEach((history) => {
            const sortedHistory = [...history]
              .sort((a, b) => (a.date < b.date ? 1 : -1))
              .sort((a, b) => (a.appointmentNo > b.appointmentNo ? 1 : -1))

            sortedHistory.forEach((sortedAppointment, index) => {
              let isDisableButton = false

              if (sortedAppointment.isDisableAppointment === true) {
                isDisableButton = true
              } else if (!sortedAppointment.constraint.canMakeAppointment) {
                isDisableButton = true
              } else if (
                index === 0 ||
                sortedHistory[index - 1].date !== "Invalid DateTime"
              ) {
                isDisableButton = false
              } else {
                isDisableButton = true
              }

              disableButtonById[sortedAppointment.id] = isDisableButton
            })
          })

          const appointmentsWithButtonState = appointments.map(
            (appointmentItem) => ({
              ...appointmentItem,
              isDisableButton:
                disableButtonById[appointmentItem.id] ??
                appointmentItem.isDisableButton,
            }),
          )

          return {
            id,
            data: {
              id,
              iconUrl,
              name,
              description,
              shortDescription,
              type,
              mainOption,
              extraOption,
              quota,
            },
            appointments: appointmentsWithButtonState,
            histories,
          }
        })
    },
    handleExpandBillingCycle(selectedAppointment) {
      const services = this.services.map((service) => {
        const appointments = service.appointments.map((appointment) => {
          const isExpandBillingCycle =
            appointment.id === selectedAppointment.id
              ? !appointment.isExpandBillingCycle
              : appointment.isExpandBillingCycle

          return {
            ...appointment,
            isExpandBillingCycle,
          }
        })

        const histories = Object.values(service.histories).map((item) => {
          const history = item.map((appointment) => {
            const isExpandBillingCycle =
              appointment.id === selectedAppointment.id
                ? !appointment.isExpandBillingCycle
                : appointment.isExpandBillingCycle

            return {
              ...appointment,
              isExpandBillingCycle,
            }
          })

          return history
        })

        return {
          ...service,
          histories,
          appointments,
        }
      })

      this.services = services
    },
    handleAppoint(appointment) {
      this.form.appointment = appointment

      this.showAppointmentMenu()
    },
    async handleConfirmAppoint() {
      const { dateTime, startTime, endTime, note } = this.form

      if (!dateTime || !startTime) {
        this.$message.error(`กรุณาเลือกวันที่ และเวลานัด`)
        return
      }

      this.hideAppointmentMenu()

      try {
        const { id: appointmentId } = this.form.appointment

        const dateTimeFormat = DateTime.fromJSDate(dateTime)
        const startDateTime = toLocaleTH(dateTimeFormat).set({
          hours: startTime.getHours(),
          minutes: startTime.getMinutes(),
        })
        const endDateTime = endTime
          ? toLocaleTH(dateTimeFormat).set({
              hours: endTime.getHours(),
              minutes: endTime.getMinutes(),
            })
          : undefined

        const params = {
          date_time: startDateTime,
          date_time_end: endDateTime,
          note: note || undefined,
        }

        await this.appoint(appointmentId, params)

        this.form.appointment = null
        this.form.dateTime = null
        this.form.startTime = null
        this.form.endTime = null
        this.form.note = null

        this.setupData()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
        this.$message.error("ไม่สามารถนัดวันได้")
      }
    },
    groupBy(lists, key) {
      return lists.reduce((group, element) => {
        const groupKey = element[key]

        return {
          ...group,
          [groupKey]: [...(group[groupKey] || []), element],
        }
      }, {})
    },
    showAppointmentMenu() {
      this.showAppointment = true
    },
    hideAppointmentMenu() {
      this.showAppointment = false
    },
    async fetchAppointmentDetail(appointmentId) {
      return baanRueJaiClient.others.supplier.getProviderAppointmentDetail(
        appointmentId,
      )
    },
    async fetchSubscriberDetail(subscriptionMemberId) {
      return baanRueJaiClient.others.supplier.getSubscriberDetail(
        subscriptionMemberId,
      )
    },
    async fetchAppointments(subscriptionMemberId, params) {
      return baanRueJaiClient.others.supplier.getAppointments(
        subscriptionMemberId,
        params,
      )
    },
    async appoint(appointmentId, params) {
      return baanRueJaiClient.others.supplier.appoint(appointmentId, params)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;

  > .dialog-box {
    background-color: $white;
    border-radius: 8px;
    width: 320px;
    max-height: 100%;
    overflow-y: auto;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $supplier-primary-color;

      p {
        padding-inline: 16px;
        padding-block: 8px;
        font-size: $font-18;
        font-weight: bold;
        color: $white;
      }

      > .close-btn {
        padding-inline: 16px;
        padding-block: 8px;
        color: $white;
        cursor: pointer;

        &:hover:not(:disabled) {
          opacity: 0.7;
        }
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
      padding: 16px;
      > .item {
        width: 100%;
      }

      > .el-date-editor.el-input,
      > .el-date-editor.el-input__inner {
        width: 100%;
      }

      > .button-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;

        > .button {
          flex: 1;
          padding-inline: 16px;
          height: 44px;
          font-weight: bold;
          font-size: $font-16;
          border-radius: 8px;
          border: none;
        }

        > .cancel {
          color: $black;
          background: transparent;
          border: 1px solid $color-light-gray-1;
          margin-right: 4px;

          &:hover:not(:disabled) {
            background: $color-light-gray-1-hover;
          }
        }

        > .submit {
          color: $white;
          background: $supplier-primary-color;
          margin-left: 4px;

          &:hover:not(:disabled) {
            background: $supplier-primary-light-color;
          }
        }
      }

      .el-textarea,
      .el-input {
        font-size: $font-16;
      }
    }
  }
}

.content-wrapper {
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: calc(28% - 12px) calc(72% - 12px);
  grid-gap: 24px;
  padding: 24px;

  > .left {
    display: flex;
    flex-direction: column;
    grid-gap: 24px;
  }

  > .right {
    display: flex;
    flex-direction: column;
    grid-gap: 24px;
  }
}

@media (max-width: ($m-size - 1)) {
  .content-wrapper {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
    padding: 16px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .content-wrapper {
    grid-template-columns: calc(38% - 8px) calc(62% - 8px);
    grid-gap: 16px;
    padding: 16px;

    > .left {
      grid-gap: 16px;
    }

    > .right {
      grid-gap: 16px;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .content-wrapper {
    grid-template-columns: calc(28% - 6px) calc(72% - 6px);
    grid-gap: 12px;
    padding: 12px;

    > .left {
      grid-gap: 12px;
    }

    > .right {
      grid-gap: 12px;
    }
  }
}
</style>
